<template lang="pug">
.menu-change(ref="menuChange")
  .menu-change-item(@click="copyDataSky")
    .menu-change-item-text Copiar Skydropx
  .menu-change-item(@click="copyDataExcel")
    .menu-change-item-text Copiar Excel
</template>

<script>
export default {
  name: 'MenuChange',

  props: {
    index: {
      type: Number,
      required: true
    }
  },

  methods: {
    copyDataSky () {
      this.$emit('copyDataSky')
      this.$store.commit('hideMenu', this.index)
    },
    copyDataExcel () {
      this.$emit('copyDataExcel')
      this.$store.commit('hideMenu', this.index)
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu-change
  display flex
  flex-direction column
  border-radius 0.5em
  border 1px solid rgba(0,0,0,0.2)
  background-color #ffffff
  position absolute
  z-index 1000
  top 3em

.menu-change-item
  padding .5em 1em
  cursor pointer

.menu-change-item-text
  white-space nowrap

.menu-change-item:hover
  background-color rgba(0,0,0,0.1)
</style>



// WEBPACK FOOTER //
// src/components/pages/change/MenuChange.vue